import { Dog, IDayMessage, IDayMessageDialog, IDog, IProfile, MessageTemplating } from '@jumpstart/core';
import AddIcon from '@mui/icons-material/Add';
import BrushIcon from '@mui/icons-material/Brush';
import RemoveIcon from '@mui/icons-material/Remove';
import SendIcon from '@mui/icons-material/Send';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import NestedMenuItem from 'material-ui-nested-menu-item';
import React, { useEffect, useState } from 'react';
import { useDocumentData, useDocument } from 'react-firebase-hooks/firestore';
import { db } from '../../../core/firebase';
import { ISubscriber } from '../schemas';
import { sendMessage } from './services/Texting';
import { doc, DocumentReference } from 'firebase/firestore';

function truncateString(str: string, num: number): string {
  // If the length of str is less than or equal to num
  // just return str--don't truncate it.
  if (str.length <= num) {
    return str;
  }
  // Return str truncated with '...' concatenated to the end of str.
  return str.slice(0, num) + '...';
}


const styles = {
    root: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },
    input: {
      marginLeft: 1,
      flex: 1
    },
    iconButton: {
      padding: '10px'
    },
    divider: {
      height: 28,
      margin: 4
    }
  };

export interface IMessageBar {
  subscriber: ISubscriber;
  profile: IProfile;
  dog: IDog;
}

function DialogMenuItem(props: { dialog: IDayMessageDialog; select: (str: string) => void; menuPosition: any, dog: IDog; profile: IProfile }) {
  const { dialog, select, menuPosition, dog, profile } = props;
  return (<Typography color="error">Fix me</Typography>)
  // return (
  //   <React.Fragment>
  //     {dialog.body ? <MenuItem
  //       dense
  //       onClick={() => select(dialog.body ? dialog.body : '')}
  //       style={{ alignItems: 'flex-start', fontSize: 12, height: '100%', width: 300, whiteSpace: 'pre-line' }}
  //     >{MessageTemplating.process(dialog.body ? dialog.body : '', dog, profile)}</MenuItem> : null}
  //     {dialog.responses ? Object.keys(dialog.responses).map((response: string) =>
  //       // <NestedMenuItem
  //       //   label={response}
  //       //   parentMenuOpen={!!menuPosition}
  //       // >
  //       //   {dialog.responses && dialog.responses.hasOwnProperty(response) ? <DialogMenuItem
  //       //     dialog={dialog.responses[response]}
  //       //     select={select}
  //       //     menuPosition={menuPosition}
  //       //     dog={dog}
  //       //     profile={profile}
  //       //   /> : null}
  //       // </NestedMenuItem>
  //     ) : null}
  //
  //   </React.Fragment>
  // );
}

export default function MessageBar(props: IMessageBar) {
  const { subscriber, profile, dog } = props;
  const [body, setBody] = useState('');
  const [error, setError] = useState<Error | null>(null);
  const [sending, setSending] = useState(false);
  const [offset, setOffset] = useState(0);
  const [staticDay] = useDocumentData<IDayMessage>(
    doc(db, `scout9-serial-message-events/DAY_${(Dog.ageFrom(
      dog.dob,
      'days'
    ) + offset).toFixed(0)}`) as DocumentReference<IDayMessage>
  );

  const [menuPosition, setMenuPosition] = useState<any>(null);

  useEffect(() => {
    setOffset(0);
  }, [subscriber]);

  const handleMenuClick = (event: React.MouseEvent) => {
    if (menuPosition) {
      return;
    }
    event.preventDefault();
    setMenuPosition({
      top: event.pageY,
      left: event.pageX
    });
  };

  const handleItemClick = (body: string) => {
    setBody(MessageTemplating.process(body, dog, profile));
    setMenuPosition(null);
  };


  const handleSubmit = () => {
    setSending(true);
    console.log('Body', body);
    console.log('Phone', subscriber.phone);
    console.log('Dog Age (days)', parseInt(Dog.ageFrom(dog.dob, 'days').toFixed(0), 10));
    const dogDaysOld = parseInt(Dog.ageFrom(dog.dob, 'days').toFixed(0), 10);
    sendMessage(
      subscriber.uid,
      MessageTemplating.process(body, dog, profile),
      subscriber.phone,
      `DAY_${dogDaysOld}`,
      dogDaysOld
    )
      .then(() => {
        setBody('');
        setSending(false);
      })
      .catch((err: Error) => {
        setError(err);
        setSending(false);
      });
  };

  return (
    <React.Fragment>
      {!!error ? <Alert severity="error" onClose={() => {
        setError(null);
      }}>{error.message}</Alert> : null}
      {!!error ? <Alert severity="error" onClose={() => {
        setError(null);
      }}>{error.message}</Alert> : null}
      <Paper sx={styles.root} elevation={0}>
        <Button
          sx={styles.iconButton}
          aria-label="menu"
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={handleMenuClick}
          size="small"
        >
          Day {staticDay ? staticDay.day : 'Missing'}
        </Button>
        <IconButton size="small" onClick={() => {setBody(MessageTemplating.process(body, dog, profile))}}><BrushIcon/></IconButton>
        <Menu
          open={!!menuPosition}
          onClose={() => setMenuPosition(null)}
          anchorReference="anchorPosition"
          anchorPosition={menuPosition}
        >
          <MenuItem dense disabled>Day {staticDay ? staticDay.day : 'Missing'} {offset === 0 ? '(Current Day)' : ''}</MenuItem>
          {staticDay ?
            <DialogMenuItem
              dialog={staticDay.dialog}
              select={handleItemClick}
              menuPosition={menuPosition}
              dog={dog}
              profile={profile}
            />
            : null}
          <Divider />
          <MenuItem dense onClick={() => setOffset(offset - 1)}>Previous Day <RemoveIcon fontSize="small"/></MenuItem>
          <MenuItem dense onClick={() => setOffset(offset + 1)}>Next Day <AddIcon fontSize="small"/></MenuItem>
        </Menu>
        <InputBase
          sx={styles.input}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setBody(event.target.value);
          }}
          placeholder="Message"
          multiline
          value={body}
        />
        <IconButton sx={styles.iconButton} aria-label="search" onClick={handleSubmit}>
          {sending ? <CircularProgress size={32}/> : <SendIcon/>}
        </IconButton>
        {/*<Divider sx={styles.divider} orientation="vertical" />*/}
        {/*<IconButton color="primary" sx={styles.iconButton} aria-label="directions">*/}
        {/*  <DirectionsIcon />*/}
        {/*</IconButton>*/}
      </Paper>
    </React.Fragment>
  );
}
